import { analytics } from '@/analytics';
import { type ChartCsvSource, chartCsvContent } from '@/components/charts/chartCsv';
import type { MetricXAxisKind } from '@/components/charts/generic';
import { saveBlob } from '@/utils/saveBlob';

/** Today as `YYYY-MM-DD`, for a downloaded file's name. */
export function fileDate(): string {
    return new Date().toISOString().split('T')[0];
}

/** Saves `chart`'s data as `<chartName>-<today>.csv` and records the export. */
export function downloadChartCsv(
    chart: ChartCsvSource,
    chartName: string,
    xHeaders: Record<MetricXAxisKind, string>
): void {
    const csv = chartCsvContent(chart, xHeaders);
    analytics.exportTriggered({ exportType: chartName, fileFormat: 'csv' });
    saveBlob(new Blob([csv], { type: 'text/csv;charset=utf-8' }), `${chartName}-${fileDate()}.csv`);
}
